import { Box, Link, theme } from '@fe-toolkit/web-components/ssr'

import { DetailsListSeparator } from '@giffgaff/broadband-common'

import { CpeOrder, OrderDetail } from '@/api'
import { ListItemCard } from '@/components/organisms'
import { formatDate } from '@/utils/formatDate/formatDate'

export type CpeOrderCardProps = {
  orderData: OrderDetail
  cpeOrderData: CpeOrder
  handleTrackPackage: (uri: string) => void
}

const availableAfterShipped = 'Available after item is shipped'

const CpeOrderCard = ({ cpeOrderData, handleTrackPackage, orderData }: CpeOrderCardProps) => {
  const deliveryAddress = orderData?.premise?.addressDisplay?.join(', ') || 'N/A'

  const estimatedDeliveryDate: string = formatDate(cpeOrderData.estimatedArrivalDateTime)

  const kitIncluded: string =
    cpeOrderData.items && cpeOrderData.items.length > 0
      ? cpeOrderData.items.map(item => `${item.quantity} x ${item.description}`).join(', ')
      : 'N/A'

  const showTrackPackageButton: boolean = !!cpeOrderData.trackingLink

  const callHandleTrackPackage = () => {
    handleTrackPackage(cpeOrderData.trackingLink ?? '')
  }

  return (
    <Box marginBottom={theme.spacing.large}>
      <ListItemCard
        backgroundColor="white"
        items={[
          {
            label: 'Delivery status',
            value: cpeOrderData.stateDescription,
          },
          {
            label: 'Estimated delivery date',
            value: estimatedDeliveryDate || availableAfterShipped,
          },
          {
            label: 'Tracking number',
            value: cpeOrderData.trackingNumber || availableAfterShipped,
          },
          {
            label: 'Delivery address',
            value: deliveryAddress,
          },
          {
            label: 'Kit included',
            value: kitIncluded,
          },
        ]}
        marginBottom={theme.spacing.small}
      >
        {showTrackPackageButton && (
          <>
            <DetailsListSeparator colour="gallery" />

            <Link chevron fullWidth as="button" onClick={callHandleTrackPackage}>
              Track package
            </Link>
          </>
        )}
      </ListItemCard>
    </Box>
  )
}

export default CpeOrderCard
